export default defineNuxtPlugin((nuxtApp) => {
    const getDefaultCachedData = (key: string) => {
        return nuxtApp.isHydrating ? nuxtApp.payload.data[key] : nuxtApp.static.data[key];
    };

    // Disponibiliza a função no nuxtApp
    nuxtApp.provide('getCachedData', getDefaultCachedData);
});
